import Loadable from "react-loadable";
import PageSpinner from "../../components/common/PageSpinner";

export default Loadable({
    loader: () => import("./OfficePage"),
    delay: 200,
    loading: PageSpinner
});
